module.exports = __webpack_public_path__ + "static/media/customercamera.5defb46d.svg";